import isString from 'lodash/isString'

import i18n from '@shared/i18n'

import { PersonType } from '@protos/person_type_pb'

import { capitalizeFirstLetter } from './string/capitalize-first-letter'

export default function () {
  const personTypeLabel: Record<PersonType, string> = {
    [PersonType.PERSON_UNKNOWN]: i18n.global.t('personType.unknown'),
    [PersonType.PERSON_CAREGIVER]: i18n.global.t('personType.caregiver'),
    [PersonType.PERSON_CLIENT]: i18n.global.t('personType.client'),
    [PersonType.PERSON_CLINICIAN]: i18n.global.t('personType.clinician'),
    [PersonType.PERSON_NURSE]: i18n.global.t('personType.nurse'),
    [PersonType.PERSON_PATIENT]: i18n.global.t('personType.patient'),
    [PersonType.PERSON_PHYSICIAN]: i18n.global.t('personType.physician'),
    [PersonType.PERSON_PROVIDER]: i18n.global.t('personType.provider'),
    [PersonType.PERSON_TECHNICIAN]: i18n.global.t('personType.technician'),
    [PersonType.PERSON_THERAPIST]: i18n.global.t('personType.therapist'),
    [PersonType.PERSON_MEMBER]: i18n.global.t('personType.member'),
    [PersonType.PERSON_EMPLOYEE]: i18n.global.t('personType.employee'),
  }

  const getPersonTypeOptions = () => {
    return Object.values(PersonType)
      .filter((key) => {
        if (!isString(key)) {
          return String(key)
        }
      })
      .map((key) => {
        return {
          text: personTypeLabel[key as PersonType],
          value: Number(key),
        }
      })
      .filter((option) => option.value !== PersonType.PERSON_UNKNOWN)
  }

  const getTypeStringByType = (type: PersonType) => {
    return capitalizeFirstLetter(personTypeLabel[type] ?? '')
  }

  return { personTypeLabel, getPersonTypeOptions, getTypeStringByType }
}
